<template>
  <div class="content">
    <div class="items">
      <PostCard
        v-for="post in posts"
        :key="post.id"
        :value="post"
      />
    </div>
  </div>
</template>
<script>
import Card from '../../../common/Card';
import PostCard from '../../../PostCard';

export default {
  name: 'Header',
  components: {
    Card,
    PostCard,
  },
  props: {
    value: {
      type: Object,
      description: 'Category object',
      required: true,
    },
  },
  data: () => ({
    posts: [],
    pagination: {
      page: 1,
    },
  }),
  computed: {
    category() {
      return this.value;
    },
  },
  beforeMount() {
    this.getPosts();
  },
  mounted() {
    document.addEventListener('scroll', async () => {
      const { scrollTop, offsetHeight } = document.documentElement;
      const bottomOfWindow = scrollTop + window.innerHeight > offsetHeight - 20;
      const lastpage = this.pagination.current_page === this.pagination.last_page;
      if (bottomOfWindow && !this.loading && !lastpage) {
        await this.nextPage();
      }
    });
  },
  methods: {
    nextPage() {
      this.pagination.page += 1;
      return this.getPosts();
    },
    async getPosts() {
      try {
        this.loading = true;
        const { data } = await window.axios
          .get(`/api/blog/categories/${this.category.id}/posts/list`, {
            params: this.pagination,
          });
        this.posts = [...this.posts, ...data.data];
        this.pagination = data.meta;
        this.pagination.page = this.pagination.current_page;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.items{
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.content{
  width: 100%;
  padding-top: 1rem;
}
</style>
